import messages from './cmsDiscardStagedEdit.json' with { type: 'json' };

export const cmsDiscardStagedEditFi: Readonly<typeof messages> = messages;
